import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { FooterService } from './footer.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, ToHtmlPipe, RouterModule, UrlParamsPipe],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit, OnDestroy {
  queryParams: any;
  constructor(
    private footerService: FooterService,
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  notRouterLink = 
  ['Developers', 'Documentation', 'API reference', 'Product demos'];
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  footerData: any;
  subscriptions: Subscription[];

  ngOnInit(): void {
    const footerData = this.footerService.getFooterData();
    this.footerService.footer$.subscribe(data => {
      let strCopy = ' Verto ' + new Date().getFullYear().toString();
      if (data != null) {
        this.footerData = {
          columns: data.footerColumns,
          logo: {
            url: data.footerLogo.fields.file.url,
            alt: data.footerLogo.title,
            link: data.footerLogo.description,
          },
          socialLinks: data.socialIcons,
          paragraph: data.footerText,
          note: data.note.content[0].content[0].value,
          copyright: strCopy,
          reserved: data.rightsReserved,
          securityCompliance: data.optionalContentPanel.fields?.image,
        };
      }
    });
  }

  onFooterLinkClick(category: string, linkText: string, linkDestination: string): void {
    this.posthog.captureFooterClick(category, linkText, {
      linkDestination: linkDestination
    });
  }

  onSocialClick(platform: string, linkDestination: string): void {
    this.posthog.captureSocialClick(platform, {
      linkDestination: linkDestination
    });
  }
}
